/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;
        this.addEventListener('submit', () => this.markDismissed());

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (!this.isDismissed() && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          if (this.querySelector('.alert')) {
            // Shown after a signup submit: show the result, then never again.
            this.markDismissed();
            this.open();
          } else if (this.isSuppressedPage()) {
            // Never on cart/checkout; suppressed on product pages so it can't cover Add to cart.
          } else if (this.dataset.trigger === 'delay') {
            this.delayTimer = setTimeout(() => this.openOnce(), Number(this.dataset.delay) * 1000);
            const pct = Number(this.dataset.scrollPercent) || 0;
            if (pct > 0) {
              this.scrollHandler = () => {
                const max = document.documentElement.scrollHeight - window.innerHeight;
                if (max > 0 && window.scrollY / max >= pct / 100) this.openOnce();
              };
              window.addEventListener('scroll', this.scrollHandler, { passive: true });
            }
            if (theme.mediaMatches.md) {
              this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
              document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
            }
          } else if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
            this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
            document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
          }
        }
      }

      isSuppressedPage() {
        const t = this.dataset.template || '';
        const p = window.location.pathname;
        return t === 'cart' || t === 'product' || /\/(cart|checkouts?)(\/|$)/.test(p) || /\/products\//.test(p);
      }

      isDismissed() {
        if (getCookie(this.cookie)) return true;
        try {
          const until = Number(localStorage.getItem(this.cookie) || 0);
          return until > Date.now();
        } catch (e) { return false; }
      }

      markDismissed() {
        const days = parseInt(this.dataset.dismissDays, 10) || 30;
        setCookie(this.cookie, true, days);
        try { localStorage.setItem(this.cookie, String(Date.now() + days * 864e5)); } catch (e) { /* ignore */ }
      }

      openOnce() {
        if (this.hasOpened || this.isDismissed()) return;
        this.hasOpened = true;
        clearTimeout(this.delayTimer);
        if (this.scrollHandler) window.removeEventListener('scroll', this.scrollHandler);
        if (this.mouseLeaveHandler) document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        this.open();
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
        if (this.scrollHandler) window.removeEventListener('scroll', this.scrollHandler);
        clearTimeout(this.delayTimer);
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        if (evt.clientY < 0) this.openOnce();
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        if (!Shopify.designMode) this.markDismissed();
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
